// Единая точка доступа к Telegram WebApp SDK: если его нет (открыли не из
// Telegram), `tg` — undefined, и весь код зовёт его методы через `?.`.
export const tg = window.Telegram?.WebApp
